import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';
import { requestCacheFn } from '@/utils/requestCache';

// 接口缓存2秒
function requestCache(obj: Recordable) {
  return requestCacheFn(obj, request, 2000);
}

// 获取样衣列表
export function getSampleList(data: any, params?: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sample/list.ac`,
    method: 'post',
    data,
    params,
  });
}

// 查询客户列表
export function getClientList(data: any, params?: any) {
  return requestCache({
    url: `${BASE_URL.scmServer}/api/admin/client/queryClientList.ac`,
    method: 'post',
    data,
    params,
  });
}

// 样品评审列表
export function getListForReview(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sample/listForReview.ac`,
    method: 'post',
    data,
    params,
  });
}

// 新增评审
export function addSampleReview(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sample/review/add.ac`,
    method: 'post',
    data,
  });
}

// 评审记录列表
export function getReviewList(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sample/review/list.ac`,
    method: 'post',
    data,
    params,
  });
}

// 批量删除
export function batchDelete(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sample/review/batchDelete.ac`,
    method: 'post',
    data,
  });
}

// 最终审评 [修改商品的审评状态 : 0-待评审 1-已通过 2-未通过]
export function finalReview(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sample/review/finalReview.ac`,
    method: 'post',
    data,
  });
}

// 样衣详情
export function getSample(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sample/getSample.ac`,
    method: 'post',
    params,
  });
}

// 查询商品的打样信息
export function getGoodsMakeSampleInfo(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/sample/make/getGoodsMakeSampleInfo.ac`,
    method: 'post',
    params,
  });
}

// 提交打样单
export function approvalConfirm(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/sample/make/approvalConfirm.ac`,
    method: 'post',
    data,
  });
}

// 查询打样单详情
export function getOrder(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/sample/make/getOrder.ac`,
    method: 'post',
    params,
  });
}

// 撤销打样单
export function destroyOrder(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/sample/make/destroy.ac`,
    method: 'post',
    params,
  });
}

// 分页查询打样单列表
export function queryList(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/sample/make/queryList.ac`,
    method: 'post',
    data,
    params,
  });
}

// 设置打样单进度状态
export function setProgressState(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/sample/make/setProgressState.ac`,
    method: 'post',
    params,
  });
}

// 指派负责人
export function assignLeader(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/sample/make/assignLeader.ac`,
    method: 'post',
    data,
  });
}

// 提交交付单[返回交付单单号]
export function delivery(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/sample/handover/approvalConfirm.ac`,
    method: 'post',
    data,
  });
}

// 获取详情[根据交付单号]
export function deliveryDetail(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/sample/handover/get.ac`,
    method: 'post',
    params,
  });
}

// 获取列表[根据打样单单号]
export function listByMakeSampleOrder(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/sample/handover/listByMakeSampleOrder.ac`,
    method: 'post',
    params,
  });
}

// 撤销交付单[根据交付单号][返回交付单单号]
export function handoverDestroy(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/sample/handover/destroy.ac`,
    method: 'post',
    params,
  });
}
